import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from 'src/app/components/not-found/not-found.component';
import { OfflineComponent } from 'src/app/components/offline/offline.component';
import { CustomerDetailsComponent } from './components/customer-details/customer-details.component';
import { EnterCustomerDetailsComponent } from './components/enter-customer-details/enter-customer-details.component';
import { PaymentComponent } from './components/payment/payment.component';
import { SelectPlanComponent } from './components/select-plan/select-plan.component';
import { StartComponent } from './components/start/start.component';
import { TestComponent } from './components/test/test.component';
import { VehicleDetailsJustBrowsingComponent } from './components/vehicle-details-just-browsing/vehicle-details-just-browsing.component';
import { ViewQuoteComponent } from './components/view-quote/view-quote.component';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  {
    // main router-outlet
    path: '', component: HomeComponent,
    children: [
      // router-outlet inside home component
      { path: '', component: StartComponent },
      { path: 'enter-details', component: EnterCustomerDetailsComponent },
      { path: 'enter-details/:transactionId', component: EnterCustomerDetailsComponent },
      { path: 'show-details', component: CustomerDetailsComponent },
      { path: 'select-plan', component: SelectPlanComponent },
      { path: 'view-quote', component: ViewQuoteComponent },
      { path: 'payment', component: PaymentComponent },
      { path: 'just-browsing/vehicle-details', component: VehicleDetailsJustBrowsingComponent },
      { path: 'just-browsing/select-plan', component: SelectPlanComponent },
      { path: 'offline', component: OfflineComponent }
    ]
  },
  { path: 'test', component: TestComponent },
  { path: '**', component: NotFoundComponent }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
